module.exports = __webpack_public_path__ + "static/media/svg-5.8aa8fce3.svg";